import React from "react";
import { Helmet } from "react-helmet-async";

import ContactDetails from "components/pages/ContactUs/ContactDetails";
import NameMeaning from "components/pages/AboutUs/NameMeaning";
import PageBanner from "components/common/PageBanner";
import Stack from "@mui/material/Stack";
import Tenets from "components/pages/AboutUs/Tenets";

function AboutUs() {
  return (
    <Stack spacing={10}>
      <Helmet>
        <title>Giới thiệu</title>
        <meta
          name="description"
          content="The English Tree mong muốn mang đến chương trình tiếng Anh có chi phí hợp lý nhất nhưng có chất lượng đào tạo vượt trội và uy tín hàng đầu khu vực."
        />
        <link rel="canonical" href="https://englishtree.edu.vn/gioi-thieu" />
      </Helmet>

      <PageBanner
        backgroundImage="/images/yellow-banner.png"
        heading="Giới thiệu"
        pageName="Giới thiệu"
      />
      <NameMeaning />
      <Tenets />
      <ContactDetails />
    </Stack>
  );
}

export default AboutUs;
